import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@material-ui/core';
import LoadingState from '../LoadingState';
import styles from './BlockingProgress.module.scss';

export default function BlockingProgress({ open, label, testId }) {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      maxWidth="xs"
      fullWidth
      PaperProps={{
        className: styles.paper,
        'aria-label': label,
        'aria-busy': true,
        'data-testid': testId,
      }}
      BackdropProps={{ className: styles.backdrop, 'data-testid': `${testId}-backdrop` }}
    >
      <LoadingState label={label} variant="compact" testId={`${testId}-status`} />
    </Dialog>
  );
}

BlockingProgress.propTypes = {
  open: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  testId: PropTypes.string,
};

BlockingProgress.defaultProps = { testId: 'blocking-progress' };
